'use strict';

// Heroのアプリ画面ギャラリー。タップ/クリックで複数スクショを切り替える。
// HAML契約: .js-hero-gallery > .lp-hero__shot（複数）／ .lp-hero__dots はギャラリーの兄弟（画像の外）
(function () {
  var SELECTOR = '.js-hero-gallery';
  var AUTOPLAY_MS = 9000; // 自動切り替え間隔
  var autoplayTimer = null;

  function init() {
    var gallery = document.querySelector(SELECTOR);
    if (!gallery || gallery.dataset.galleryBound === 'true') return;

    var shots = Array.prototype.slice.call(gallery.querySelectorAll('.lp-hero__shot'));
    if (shots.length < 2) return;

    // ドット・フロートラベルはギャラリーの外（兄弟要素）にあるため親スコープから取得する
    var dotsWrap = gallery.parentElement
      ? gallery.parentElement.querySelector('.lp-hero__dots')
      : null;
    var labelEl = gallery.parentElement
      ? gallery.parentElement.querySelector('.js-hero-label')
      : null;
    gallery.dataset.galleryBound = 'true';

    // ドット生成
    var dots = [];
    if (dotsWrap) {
      shots.forEach(function (_shot, i) {
        var dot = document.createElement('span');
        dot.className = 'lp-hero__dot' + (i === 0 ? ' is-active' : '');
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    var current = 0;

    // 表示中スクショの data-label をフロートに反映する（テキストのみ・HTMLは入れない）
    function updateLabel() {
      if (!labelEl) return;
      var label = shots[current].dataset.label;
      if (label) labelEl.textContent = label;
    }

    function show(index) {
      if (index === current) return;
      shots[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = index;
      shots[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
      updateLabel();
    }

    function showNext() {
      show((current + 1) % shots.length);
    }

    // 自動切り替え。手動操作時はリセットして直後の切り替わりを防ぐ。
    function startAutoplay() {
      stopAutoplay();
      autoplayTimer = window.setInterval(showNext, AUTOPLAY_MS);
    }

    function stopAutoplay() {
      if (autoplayTimer !== null) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function manualNext() {
      showNext();
      startAutoplay();
    }

    // クリック/タップで切り替え（ホバーでは切り替えない）
    gallery.addEventListener('click', manualNext);
    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        manualNext();
      }
    });

    updateLabel();
    startAutoplay();
  }

  // Turbolinksキャッシュ復元時に重複ドット・状態リセットを防ぐ
  function cleanup() {
    if (autoplayTimer !== null) {
      window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
    var gallery = document.querySelector(SELECTOR);
    if (!gallery) return;
    var dotsWrap = gallery.parentElement
      ? gallery.parentElement.querySelector('.lp-hero__dots')
      : null;
    if (dotsWrap) dotsWrap.innerHTML = '';
    var shots = Array.prototype.slice.call(gallery.querySelectorAll('.lp-hero__shot'));
    shots.forEach(function (shot, i) {
      shot.classList.toggle('is-active', i === 0);
    });
    // 先頭スクショに状態を戻すのに合わせてフロートのラベルも戻す
    var labelEl = gallery.parentElement
      ? gallery.parentElement.querySelector('.js-hero-label')
      : null;
    if (labelEl && shots[0] && shots[0].dataset.label) {
      labelEl.textContent = shots[0].dataset.label;
    }
    delete gallery.dataset.galleryBound;
  }

  document.addEventListener('turbolinks:load', init);
  document.addEventListener('turbolinks:before-cache', cleanup);
})();
